import {
  ThemeOptions,
  createTheme as createMuiTheme
} from "@material-ui/core/styles";

export default function createTheme({custom, ...options}: ThemeOptions) {
  return createMuiTheme({
    custom,
    ...options,
  });
}
